export default function Loading() {
  return (
    <div className="loading text-danger">
      <div className="spinner-border" role="status"></div>
    </div>
  );
}
